// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"32d93e2e","732":"791f60c6","977":"e6793a09"}[chunkId] + ".chunk.js";
};